var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentLink18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 3.697A3.75 3.75 0 1114.303 9l-.795.796a3.763 3.763 0 00-.221-1.902 2.25 2.25 0 00-3.226-3.136L7.939 6.879a2.25 2.25 0 00-.053 3.127l.053.055-1.06 1.06a3.75 3.75 0 010-5.303l2.12-2.121z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.697 9l.742-.742a3.763 3.763 0 00.223 1.905 2.25 2.25 0 003.278 3.08l2.12-2.121A2.25 2.25 0 009.44 7.5l1.098-1.098a3.75 3.75 0 01.583 5.78l-2.12 2.122A3.75 3.75 0 113.696 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentLink18);
export default __webpack_public_path__ + "dd9c0d8cdd1ea90275e829a8d11170ad.svg";
export { ForwardRef as ReactComponent };